export default function () {
  let assetPath = "/public"; // To read from public folder
  assetPath = ""; // in PROD env, the public folders are on root
  return assetPath;
}
